const home = {
  heroTitle: 'BB彩票平台APP',
  heroSubtitle: '安全正规的手机彩票购买软件',
  heroDesc: '支持双色球、大乐透、快三等多种彩票在线购买，实时开奖查询，极速到账，海量用户信赖之选。',
  heroCta: '立即下载BB彩票APP',
  heroCtaSecondary: '了解更多',
  statsUsers: '累计用户',
  statsUsersValue: '500万+',
  statsOrders: '累计订单',
  statsOrdersValue: '1.2亿+',
  statsPayout: '累计兑奖',
  statsPayoutValue: '89亿+',
  statsRating: '用户评分',
  statsRatingValue: '4.9',
  featuresTitle: '为什么选择BB彩票平台',
  featuresSubtitle: '五大核心优势，打造值得信赖的购彩体验',
  featureSafetyTitle: '安全合规',
  featureSafetyDesc: '持有国家正规彩票销售资质，资金由银行托管，交易全程加密，保障用户资金安全。',
  featureSpeedTitle: '极速到账',
  featureSpeedDesc: '中奖奖金秒级到账，支持微信、支付宝、银行卡多种提现方式，到账速度行业领先。',
  featureVarietyTitle: '玩法齐全',
  featureVarietyDesc: '涵盖双色球、大乐透、快三、福彩3D、排列三、时时彩等十余种主流彩票玩法。',
  featureServiceTitle: '贴心服务',
  featureServiceDesc: '7×24小时专业客服团队，在线答疑、购彩指导、中奖提醒，全心全意为彩民服务。',
  featureDataTitle: '数据精准',
  featureDataDesc: '实时同步官方开奖数据，历史开奖号码完整可查，走势图表专业详尽，助您理性投注。',
  lotteryTitle: '热门彩票玩法',
  lotterySubtitle: '多种玩法任您选择，总有一款适合您',
  howItWorksTitle: '三步轻松购彩',
  howItWorksSubtitle: '简单快捷的操作流程，让购彩变得轻松愉快',
  step1Title: '注册账号',
  step1Desc: '手机号快速注册，完成实名认证，开启购彩之旅。',
  step2Title: '选择玩法',
  step2Desc: '浏览各类彩票玩法，选择心仪号码或机选号码进行投注。',
  step3Title: '等待开奖',
  step3Desc: '关注开奖时间，中奖后奖金自动到账，提现秒到银行卡。',
  testimonialsTitle: '用户真实评价',
  testimonialsSubtitle: '百万彩民的信赖之选',
  faqTitle: '常见问题',
  faqSubtitle: '关于BB彩票平台，您想了解的都在这',
  ctaTitle: '立即下载BB彩票APP',
  ctaSubtitle: '加入500万彩民的选择，开启您的幸运之旅',
  ctaButton: '免费下载APP',
  articlesTitle: '最新彩票资讯',
  articlesSubtitle: '掌握行业动态，了解最新玩法攻略',
};

export default home;